var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"partnership"},[_c('partnership-flow',{attrs:{"partner":_vm.$route.params.partner}}),_c('illustration-mosaic')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }